<div class="chat-with-surveys-dialog">
    <div class="dialog-header">
      <h2>Chat with Surveys</h2>
      <div class="reportsbtn-closeicon">
        <button class="primary-button" (click)="redirectToDashboard()">
          Reports
        </button>
        <mat-icon class="close-icon" (click)="close()">close</mat-icon>
      </div>
    
    </div>
    
    <div class="dialog-description">
      <p> This tool helps you understand survey data using AI. You can select multiple surveys, ask specific questions in Q&A mode, or get a full summary. Just pick your surveys and set a date range to get started.
      </p>
    </div>

    
    <div class="dialog-content">
      <div class="left-panel">
        <form [formGroup]="surveyForm">
          <div class="survey-selector-section">
            <label>Select Surveys</label>
            <div class="survey-selector full-width">
            <div class="matSelect-filters">
              <mat-select placeholder="Select surveys" multiple [(value)]="selectedSurveys">
                <mat-option *ngFor="let survey of surveys" [value]="survey">
                  {{ survey.name }}
                </mat-option>
              </mat-select>
            </div>
               
              
              <div class="selected-surveys" *ngIf="selectedSurveys.length > 0">
                <div class="survey-chip" *ngFor="let survey of selectedSurveys">
                  {{ survey.name }}
                    <div class="close-icon-2 material-icons " (click)="removeSurvey(survey)">close</div>
                </div>
              </div>
            </div>
          </div>
          
          <div class="analysis-type-section">
            <label>Analysis Type</label>
            <div>
              <mat-radio-group formControlName="analysisType" class="radio-options">
                <mat-radio-button color="primary"  value="Q&A">Q&A</mat-radio-button>
                <mat-radio-button color="primary"  value="Summary">Summary</mat-radio-button>
              </mat-radio-group>
            </div>
          </div>
          
          <div class="form-section date-range">
            <div class="date-field">
              <label>Start Date</label>
              <mat-form-field appearance="outline" class="remove-outline" [ngClass]="{'error-border': surveyForm.get('startDate').touched && surveyForm.get('startDate').invalid}">
                <input matInput [matDatepicker]="startPicker" formControlName="startDate" placeholder="Pick a date" [max]="today">
                <mat-datepicker-toggle matSuffix [for]="startPicker"></mat-datepicker-toggle>
                <mat-datepicker #startPicker></mat-datepicker>
              </mat-form-field>
            </div>
            
            <div class="date-field">
              <label>End Date</label>
              <mat-form-field appearance="outline" class="remove-outline" [ngClass]="{'error-border': surveyForm.get('endDate').touched && surveyForm.get('endDate').invalid}">
                <input matInput [matDatepicker]="endPicker" formControlName="endDate" placeholder="Pick a date" [max]="today">
                <mat-datepicker-toggle matSuffix [for]="endPicker"></mat-datepicker-toggle>
                <mat-datepicker #endPicker></mat-datepicker>
              </mat-form-field>
            </div>
          </div>
          
          <div class="form-section" *ngIf="surveyForm.get('analysisType').value === 'Q&A'">
            <label>Question</label>
            <mat-form-field appearance="outline" class="full-width">
              <textarea matInput formControlName="question" placeholder="Enter your question here..." rows="11" class="no-resize"></textarea>
            </mat-form-field>
          </div>
          
          <button class="primary-button" (click)="generateInsights()">
              Generate Insights
          </button>
        </form>
      </div>
      
      <div class="right-panel">
        <div class="results-container">
          <h3>Results</h3>
          <ng-container *ngIf="isLoading">
            <div class="loading-container">
              <app-qubriux-loading
              [size]="45"
              [loadingText]="'Generating Insights'"
            ></app-qubriux-loading>
            </div>
          </ng-container>
          
          <ng-container *ngIf="!isLoading && !resultsGenerated">
            <div class="no-results">
              <span class="instruction-text">Please choose filters and click generate to see insights.</span>
            </div>
          </ng-container>
          
          <ng-container *ngIf="!isLoading && resultsGenerated">
            <div class="results-content">
              <p>{{ results.output_text }}</p>
            </div>
          </ng-container>
        </div>
      </div>
    </div>
  </div>